
const NotFoundPage = () => {
    return (
        <div className="not-found-page-wrapper">
        <h1>404 Not Found</h1>
        </div>
    );
};

export default NotFoundPage;